// eslint-disable-next-line @tseslint/typedef, @tseslint/no-unnecessary-type-assertion
export const ACCESS_CONTROL_ROLE_RESOURCE = "access-control" as const;
// eslint-disable-next-line @tseslint/typedef
export const ACCESS_CONTROL_ROLES = {
  identificationCardEdit: "access_control_identification_card_edit",
  presenceView: "access_control_presence_view",
  readerUnitDelete: "access_control_reader_unit_delete",
  minimumWageSettings: "minimum_wage_settings",
  terminalAdmin: "access_control_terminal_admin",
  terminalView: "access_control_terminal_view",
  terminalEdit: "access_control_terminal_edit",
  attendanceListView: "access_control_attendance_list_view",
  reportAdmin: "access_control_report_admin",
  attendanceListCreate: "access_control_attendance_list_create",
  overviewIdCardsCreate: "access_control_overview_id_cards_create",
  terminalCreate: "access_control_terminal_create",
  readerUnitCreate: "access_control_reader_unit_create",
  identificationCardAdmin: "access_control_identification_card_admin",
  terminalCreateCommand: "access_control_terminal_create_command",
  readerUnitView: "access_control_reader_unit_view",
  minimumWageView: "access_control_minimum_wage_view",
  readerUnitAdmin: "access_control_reader_unit_admin",
  terminalDelete: "access_control_terminal_delete",
  identificationCardView: "access_control_identification_card_view",
  identificationCardCreate: "access_control_identification_card_create",
  minimumWageAdmin: "access_control_minimum_wage_admin",
  overviewIdCardsView: "access_control_overview_id_cards_view",
  readerUnitEdit: "access_control_reader_unit_edit",
  reportView: "access_control_report_view",
  admin: "access_control_admin",
  customerStructureCreate: "access_control_customer_structure_create",
  minimumWageEdit: "access_control_minimum_wage_edit",
  minimumWageEmployeeView: "minimum_wage_employee_view",
  reportCreate: "access_control_report_create",
  minimumWageCreate: "access_control_minimum_wage_create",
  identificationCardDelete: "access_control_identification_card_delete"
} as const;
export type AccessControlRole = typeof ACCESS_CONTROL_ROLES[keyof typeof ACCESS_CONTROL_ROLES];

const allAccessControlRoles: string[] = Object.values(ACCESS_CONTROL_ROLES) as string[];

export function isAccessControlRole (role: string): role is AccessControlRole {
  return allAccessControlRoles.includes(role);
}
